import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'
import mixpanelService from './MixpanelService'
import storeCountry from 'GlobalStores/Cores/County/StoreCountry'
import StoreTranslate from 'GlobalStores/Cores/Translator/StoreTranslate'
import mixpanelCookieService from 'Services/Cookie/MixpanelCookieService'
import { observer } from 'mobx-react-lite'

const MixpanelRouteObserver = observer(() => {

    const location = useLocation()
    const navigationType = useNavigationType()
    const previousPath = useRef('')
    const [hasTrackedInitialPageView, setHasTrackedInitialPageView] = useState(false)

    const handleTrackPageViewEvent = async (currentPath) => {

        // console.log("[DEBUG VIEW 👀] handleTrackPageViewEvent", {
        //     currentPath,
        // })
        await mixpanelService.handleTrackPageViewEvent()

        previousPath.current = currentPath
        mixpanelService.previousPath = window.location.href
    }

    // Only track the initial page view event
    useEffect(() => {
        // console.log("[DEBUG VIEW 👀] useEffect [1]")
        if (
            !hasTrackedInitialPageView &&
            StoreTranslate.CurrentLanguage() &&
            storeCountry.Country2()
        ) {
            previousPath.current = location.pathname + location.search
            mixpanelService.initializeSuperProperties()
            handleTrackPageViewEvent()
            setHasTrackedInitialPageView(true)
            // mixpanelService.previousPath = window.location.href
        }
    }, [
        // StoreTranslate.CurrentLanguage(),
        // storeCountry.Country2(),
        // hasTrackedInitialPageView,
        // location.pathname,
        // location.search
    ])


    useEffect(() => {
        if (!hasTrackedInitialPageView) return

        const currentPath = location.pathname + location.search

        if (previousPath.current === currentPath) return

        mixpanelService.initializeSuperProperties()
        handleTrackPageViewEvent(currentPath)
    }, [location.pathname, location.search, navigationType])


    useEffect(() => {
        // console.log('storeCountry.Country2()', toJS(storeCountry.Country2()))
        mixpanelService.registerSuperProperties({
            user_market_extended: storeCountry.Country2(),
        })
    }, [storeCountry.Country2()])

    useEffect(() => {
        // console.log('StoreTranslate.CurrentLanguage()', toJS(StoreTranslate.CurrentLanguage()))
        mixpanelService.registerSuperProperties({
            user_language: StoreTranslate.CurrentLanguage().toLowerCase(),
        })
    }, [StoreTranslate.CurrentLanguage()])


    // Clear cookies when tab is closed/refreshed/navigated away
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            console.log('handleBeforeUnload')
            // Clear mixpanel cookies
            mixpanelCookieService.clearInitialReferrerAndReferringDomain()

            // Note: You can also be more selective about which cookies to clear
            // mixpanelCookieService.clearWhenUserLoggedOut()
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [])

    return true


})


export default MixpanelRouteObserver